import React from 'react'
import styled from 'styled-components'
import { FiChevronRight } from 'react-icons/fi'

import { revenueType, type } from '../../../../project-information/tab-content/tab-revenue-planning/constants'
import { FONTS } from '../../../../../constants'
import { formatNumber, findPercentage } from '../../../../../function/math'

const findCrIndex = (crRevenue, cr_id) => {
  const index = crRevenue.findIndex(c => c.cr_id === cr_id)
  return `CR-${index + 1}`
}

export const Header = React.memo((props) => {
  const {
    data = {},
    crRevenue,
    index,
    isExpand,
    profitData,
    handleExpandTable,
  } = props

  const productName = data._product_name || 'Untitled'
  const name = data.type === 'CR' ? revenueType[data.cr_type].name : productName
  const current = profitData.$price_cost_current_price
  const percentage = findPercentage(data.revenue, current)

  return (
    <Root onClick={ () => handleExpandTable(index) }>
      <LeftWrapper>
        <ProjectCol>
          <TagWrapper active={ isExpand }>
            <FiChevronRight
              id='arrow'
              style={ { color: '#C4C4C4', marginRight: 12 } }
            />
            <Tag color={ revenueType[data.type] ? revenueType[data.type].color : '' }>
              <StickyText>{ data.type === 'CR' ? findCrIndex(crRevenue, data.cr_id) : revenueType[data.type].name }</StickyText>
            </Tag>
          </TagWrapper>
        </ProjectCol>
        <AvailableCol>
          { name !== '-' && data.type !== type.SERVICE &&
          <React.Fragment>
            <Dot color={ revenueType[data.type] ? revenueType[data.type].color : '' } />
            <AvailableText>{ name }</AvailableText>
            <div className='tooltip'>{ name }</div>
          </React.Fragment>
          }
        </AvailableCol>
        <RevenueWrapper>
          <RevenueCol>
            <HeaderText>Revenue</HeaderText>
            <HeaderNumber>{`฿ ${formatNumber(data.revenue)}`}</HeaderNumber>
          </RevenueCol>
          <PercentageCol>
            <HeaderText>Percentage</HeaderText>
            <HeaderNumber>{`${percentage} %`}</HeaderNumber>
          </PercentageCol>
        </RevenueWrapper>
      </LeftWrapper>
      <Wrapper />
    </Root>
  )
})

const Root = styled.div`
  height: 48px;
  display: flex;
  flex: 1;
  background: #FAFAFA;
  cursor: pointer;
`

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-basis: 60%;
  padding: 0 18px;
`

const LeftWrapper = styled(Wrapper)`
  flex-basis: 40%;
  justify-content: space-between;
`

const ProjectCol = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 6px 0 0;
`

const RevenueWrapper = styled.div`
  display: flex;
`

const AvailableCol = styled.div`
  width: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  padding: 0 6px;
  position: relative;

  .tooltip {
    width: 100%;
    min-width: 200px;
    max-width: 300px;
    position: absolute;
    top: 40px;
    background-color: #fff;
    font-family: ${FONTS.GOTHAM};
    font-size: 12px;
    padding: 5px;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }

  :hover {
    .tooltip {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
  }
`

const RevenueCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  flex: 2;
  padding: 0 6px;
`

const PercentageCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
  padding: 0 16px 0 6px;

  :nth-last-child(1) {
    padding-right: 0;
  }
`

const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  
  #arrow {
    transform: ${p => (p.active ? 'rotate(90deg)' : 'rotate(0deg)')};
    transition: all 0.3s;
  }
`

const Tag = styled.div`
  height: 24px;
  width: 82px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => p.color};
  border-radius: 4px;

  span {
      color: #FFFFFF;
  }
`

const StickyText = styled.span`
  height: 14px;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #C4C4C4;
`

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: ${p => p.color};
  border-radius: 50%;
  margin-right: 4px;
`

const AvailableText = styled.span`
  height: 14px;
  flex: 1;
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #9BA3AB;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #C4C4C4;
`

const HeaderNumber = styled.span`
  font-family: NotoSans;
  font-weight: 600;
  font-size: 12px;
  color: #1A1A17;
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/header/index.js